import DropdownContainer from "./DropdownMenu";
import DropdownMenuItem from "./DropdownMenuItem";
import DropdownMenuItems from "./DropdownMenuItems";
import DropdownMenuTrigger from "./DropdownMenuTrigger";

const DropdownMenu = {
    Container: DropdownContainer,
    Trigger: DropdownMenuTrigger,
    Items: DropdownMenuItems,
    Item: DropdownMenuItem,
};

export default DropdownMenu;
